import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  bulletins: [],
  count: 0,
  unreadedBulletins: 0,
  loading: false,
}

const bulletins = createSlice({
  name: 'bulletins',
  initialState,
  reducers: {
    getBulletinsRequest(state) {
      state.loading = true
    },
    getBulletinsSuccess(state, { payload }) {
      state.bulletins = payload.bulletins
      state.count = payload.count
      state.loading = false
    },
    getBulletinsFailure(state) {
      state.loading = false
    },
    readBulletinRequest() {},
    unreadedBulletinsRequest() {},
    unreadedBulletinsSuccess(state, { payload }) {
      state.unreadedBulletins = payload
    },

    createBulletinRequest(state) {
      state.loading = true
    },
    createBulletinSuccess(state, { payload }) {
      state.loading = false
      state.bulletins.push(payload)
    },
    createBulletinFailure(state) {
      state.loading = false
    },
  },
})

export const {
  getBulletinsRequest,
  getBulletinsSuccess,
  getBulletinsFailure,
  readBulletinRequest,
  unreadedBulletinsRequest,
  unreadedBulletinsSuccess,
  createBulletinRequest,
  createBulletinSuccess,
  createBulletinFailure,
} = bulletins.actions
export default bulletins.reducer
